<template>
    <button class="btn btn-lg btn-info btn-flex offer-selector__button"
            :class="[
                selected ? 'active' : '',
                offer.applyPerTriggerLimit ? 'multi-select' : '',
                offer.requiresSupervisorApproval ? 'offer-selector__button--requires-supervisor-permission' : ''
            ]"
            :disabled="disabled"
            @click.prevent="$emit('select', offer)">
        <span v-if="selected && offer.applyPerTriggerLimit"
              class="select-count">
            {{ selectedCount }}x
        </span>

        <a v-if="selected"
           class="btn btn-default deselect-btn"
           @click.stop.prevent="$emit('deselect', offer)">
            <i class="fa-solid fa-circle-x"></i>
        </a>

        <span class="offer-selector__button-offer-name dt-search-filter-text">
            {{ offer.name }}
        </span>

        <span v-if="offer.code"
              class="offer-selector__button-offer-code dt-search-filter-text">
            <i class="fa-solid fa-tags"></i>
            {{ offer.code }}
        </span>

        <small class="offer-selector__button-offer-info">
            <span v-if="offer.valueType === 'percent'">
                {{ numberFilter(offer.value) }}% {{ l('CART_OFFERS.DISCOUNT') }}
            </span>
            <span v-else-if="offer.valueType === 'value'">
                {{ currencyFilter(offer.value) }} {{ l('CART_OFFERS.DISCOUNT') }}
            </span>
            <span v-else-if="offer.valueType === 'variable' && variableDiscountsCollection">
                <em v-if="variableDiscountsCollection.discounts[offer.ID]">
                    {{ currencyFilter(variableDiscountsCollection.discounts[offer.ID].amount) }}
                    {{ l('CART_OFFERS.DISCOUNT') }} ({{ l('CART_OFFERS.VARIABLE') }})
                </em>
                <em v-else>{{ l('CART_OFFERS.VARIABLE_DISCOUNT') }}</em>
            </span>

            <span v-if="offer.applyPerTriggerLimit === 1">
                {{ l('CART_OFFERS.FOR_1_ITEM') }}
            </span>
            <span v-else-if="offer.applyPerTriggerLimit > 1">
                {{ l('CART_OFFERS.FOR_MULTIPLE_ITEMS', {count:offer.applyPerTriggerLimit}) }}
            </span>
        </small>
    </button>
</template>

<script>

export default {
    name: 'OfferButton',

    props: {
        offer: {
            type: Object,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
        selectedCount: {
            type: Number,
            default: 1,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        variableDiscountsCollection: {
            type: Object,
            default: null,
        },
    },

    emits: ['select', 'deselect'],
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables";
@import (reference) "../../../../less/vendor/fontawesome.less";

.offer-selector {
    // When the apply supervisor offers permission hasn't been granted:
    &:not(.offer-selector--has-supervisor-permission) {
        // Grey out supervisor-only offers
        .offer-selector__button--requires-supervisor-permission {
            background: @dt-grey;
            border-color: @dt-grey;

            // Add a lock icon on the left of the offer name
            .offer-selector__button-offer-name:before {
                font-family: @fontawesome-font-family;
                font-weight: @fontawesome-font-weight-solid;
                content: @fa-var-lock;
                margin-right: 5px;
                font-size: 11px;
                position: relative;
                top: -1px;
            }
        }
    }

    .offer-selector__button-offer-code {
        font-family: @font-family-monospace;
        display: inline-block;
        padding: 2px 5px;
        line-height: 22px;
        margin: 2px;
        vertical-align: middle;
        background: rgba(0, 0, 0, .2);
        border-radius: @border-radius-base;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
}
</style>
